import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-help-saved-reports',
  templateUrl: './help-saved-reports.component.html',
  styleUrls: ['./help-saved-reports.component.scss']
})
export class HelpSavedReportsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
